<template>
    <CCard>
        <CCardHeader>
            <h5>Vendor Allocation</h5>

            <CTabs variant="tabs" :active-tab="0" @update:activeTab="handleTabChange">
                <CTab title="Mapped">
                    <CCardBody>
                        <Mapped ref="mapped" />
                    </CCardBody>
                </CTab>
                <CTab title="Unmapped AP">
                    <CCardBody>
                        <UnmappedAP ref="unmappedAP" />
                    </CCardBody>
                </CTab>
                <CTab title="Unmapped PO">
                    <CCardBody>
                        <UnmappedPo ref="unmappedPO" />
                    </CCardBody>
                </CTab>
            </CTabs>
        </CCardHeader>
        <CCardFooter>
            <CButton
                type="submit"
                color="success"
                class="m-1"
                @click="handleSaveVendor"
                :disabled="activeTab === 0"
            >
                Save Allocation
            </CButton>
            <CButton
                type="reset"
                color="secondary"
                class="m-1"
                @click="$router.back()"
                >Cancel</CButton
            >
        </CCardFooter>

        <Success
            name="modal"
            :modal="success.enable"
            :message="success.message"
            :color="success.color"
            @close="success.enable = false"
            @res-handler="handleSuccess()"
        />

        <Error
            :modal="error.enable"
            :message="error.message"
            @close="error.enable = false"
        />

        <CElementCover v-if="spinner" :opacity="0.8" />
    </CCard>
</template>

<script>
import { INSERT_AP_CATEGORIES, INSERT_PO_CATEGORIES } from "./vendorQueries";

import Mapped from "./components/Mapped";
import UnmappedAP from "./components/UnmappedAP";
import UnmappedPo from "./components/UnmappedPo";

export default {
    data() {
        return {
            success: { enable: false, message: "", color: null },
            error: { enable: false, message: "" },
            update: false,
            spinner: false,
            vendorId: null,
            activeTab: 0
        };
    },
    components: { Mapped, UnmappedAP, UnmappedPo },
    methods: {
        handleSuccess() {
            this.success.enable = false;
            this.$router.go();
        },

        handleTabChange(tabIndex) {
            this.activeTab = tabIndex;
        },

        async handleSaveVendor() {
            this.spinner = true;

            let vendorData, vendorAllocations, totalAllocation;

            switch(this.activeTab) {
                case 0: // Mapped tab
                    if (this.$refs.mapped) {
                        return;
                    }
                    break;

                case 1: // Unmapped AP tab
                    if (this.$refs.unmappedAP) {
                        vendorData = this.$refs.unmappedAP.getVendorForm();
                        const apAllocation = this.$refs.unmappedAP.getVendorAllocation();
                        vendorAllocations = apAllocation?.vendorAllocations;
                        totalAllocation = apAllocation?.totalAllocation;
                    }
                    break;

                case 2: // Unmapped PO tab
                    if (this.$refs.unmappedPO) {
                        vendorData = this.$refs.unmappedPO.getVendorForm();
                        const poAllocation = this.$refs.unmappedPO.getVendorAllocation();
                        vendorAllocations = poAllocation?.vendorAllocations;
                        totalAllocation = poAllocation?.totalAllocation;

                        console.log("unmappedPO vendorData", vendorData);
                        console.log("unmappedPO vendorAllocations", vendorAllocations);
                        console.log("unmappedPO totalAllocation", totalAllocation);
                    }
                    break;
            }

            if (!vendorData || !vendorAllocations) {
                this.error.enable = true;
                this.error.message = "Please select vendor and allocations";
                this.spinner = false;
                return;
            }

            if (totalAllocation !== 100) {
                this.error.enable = true;
                this.error.message = "Allocation should be 100%";
                this.spinner = false;
                return;
            }

            try {
                const mutation = this.activeTab === 2 ? INSERT_PO_CATEGORIES : INSERT_AP_CATEGORIES;
                const res = await this.$apollo.mutate({
                    mutation,
                    variables: {
                        categories: vendorAllocations,
                        client: vendorData.client_id,
                        vendor_id: vendorData.vendor_id,
                    },
                });

                const successData = this.activeTab === 2
                    ? res.data?.spendmd_db_insert_po_categories
                    : res.data?.spendmd_db_insert_categories_test;

                if (successData) {
                    const tabNames = ['Mapped', 'Unmapped AP', 'Unmapped PO'];
                    this.success = {
                        enable: true,
                        message: `${tabNames[this.activeTab]} vendor categories updated successfully`,
                    };

                    // Reset any previous errors
                    this.error = {
                        enable: false,
                        message: "",
                    };
                } else {
                    throw new Error("No data returned from mutation");
                }
            } catch (error) {
                console.error("Error updating vendor categories:", error);
                this.error = {
                    enable: true,
                    message:
                        error.message || "Failed to update vendor categories",
                };
                // Reset success state on error
                this.success = {
                    enable: false,
                    message: "",
                };
            }
            this.spinner = false;
        },
    },
    beforeMount() {
        // Reload the page when component is mounted
        this.update = this.$route.path.includes("edit");
        if (this.update) {
            this.vendorId = this.$route.params.id;
        }
    },
};
</script>

<style scoped></style>
